import { useCssVars as _useCssVars, defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, unref as _unref, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, Teleport as _Teleport, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "sidebar-list-checkbox" }
const _hoisted_2 = { class: "header" }
const _hoisted_3 = { class: "close" }
const _hoisted_4 = { class: "header-title" }
const _hoisted_5 = { class: "content" }
const _hoisted_6 = { class: "header" }
const _hoisted_7 = { class: "close" }
const _hoisted_8 = { class: "header-title" }
const _hoisted_9 = { class: "icon" }
const _hoisted_10 = { class: "header-subtitle" }
const _hoisted_11 = { class: "content" }

import { computed, onBeforeUnmount, onMounted, ref } from "vue";
import { useI18n } from "vue-i18n";
import { sanitizeText } from "@/common/utils/text";
import {
  baseInput,
  baseCheckbox,
  baseLoading,
  svgIcon,
} from "@/common/components";


export default /*@__PURE__*/_defineComponent({
  __name: 'sidebar-list-checkbox',
  props: {
    id: {},
    title: {},
    fieldId: {},
    fieldOption: {},
    list: {},
    added: {},
    open: { type: Boolean, default: false },
    width: { default: "50rem" },
    loading: { type: Boolean, default: false },
    outsideClose: { type: Boolean, default: true }
  },
  emits: ["close", "add:item", "remove:item"],
  setup(__props: any, { emit: __emit }) {

_useCssVars(_ctx => ({
  "v7cacec45": (props.width)
}))

const props = __props;

const { t } = useI18n();
const emit = __emit;

const search = ref("");
const internalOpen = ref(props.open);

const options = computed(() =>
  props.list
    ?.filter((item) => {
      if (search.value?.trim()) {
        const name = sanitizeText(
          (item[props.fieldOption] || "").toLowerCase()
        );
        const searching = sanitizeText((search.value || "").toLowerCase());

        if (name.includes(searching)) return item;
      } else {
        return item;
      }
    })
    ?.map((item) => ({
      id: item[props.fieldId],
      option: item[props.fieldOption],
      value: props.added.includes(item[props.fieldId]),
    }))
);

function checked(data: any) {
  const [option] = props.list?.filter(
    (item) => item[props.fieldId] === data.id
  );

  if (option) {
    if (data.value) {
      emit("add:item", option);
    } else {
      emit("remove:item", option);
    }
  }
}

function addHidePageScroll() {
  document.querySelector("html")?.classList.add("no-scroll");
}

function removeHidePageScroll() {
  document.querySelector("html")?.classList.remove("no-scroll");
}

function sidebarClose() {
  internalOpen.value = false;

  setTimeout(() => {
    emit("close");
  }, 350);
}

function sidebarOutsideClose() {
  if (props.outsideClose) sidebarClose();
}

onBeforeUnmount(() => {
  removeHidePageScroll();
});

onMounted(() => {
  addHidePageScroll();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
    _createElementVNode("article", _hoisted_1, [
      _createElementVNode("div", {
        class: "outside",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (sidebarOutsideClose()))
      }),
      _createElementVNode("section", {
        class: _normalizeClass(["sidebar", {
          'slide-left': props.open && internalOpen.value,
          'slide-right': !internalOpen.value,
        }])
      }, [
        (props.loading)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _createElementVNode("div", _hoisted_2, [
                _createElementVNode("div", _hoisted_3, [
                  _createElementVNode("button", {
                    class: "btn btn-default",
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (sidebarClose()))
                  }, "x")
                ]),
                _createElementVNode("section", _hoisted_4, _toDisplayString(props.title), 1)
              ]),
              _createElementVNode("div", _hoisted_5, [
                _createVNode(_unref(baseLoading))
              ])
            ], 64))
          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("button", {
                    class: "btn btn-default",
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (sidebarClose()))
                  }, "x")
                ]),
                _createElementVNode("section", _hoisted_8, _toDisplayString(props.title), 1),
                _createVNode(_unref(baseInput), {
                  modelValue: search.value,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((search).value = $event)),
                  background: "#fff",
                  color: "#000",
                  placeholder: _unref(t)('common.labels.search')
                }, {
                  sufix: _withCtx(() => [
                    _createElementVNode("div", _hoisted_9, [
                      _createVNode(_unref(svgIcon), {
                        icon: "search",
                        size: "1.75rem"
                      })
                    ])
                  ]),
                  _: 1
                }, 8, ["modelValue", "placeholder"]),
                _createElementVNode("div", _hoisted_10, _toDisplayString(_unref(t)("common.texts.search_multiple")), 1)
              ]),
              _createElementVNode("div", _hoisted_11, [
                _createVNode(_unref(baseCheckbox), {
                  id: props.id,
                  options: options.value,
                  value: options.value,
                  onChecked: _cache[4] || (_cache[4] = ($event: any) => (checked($event)))
                }, null, 8, ["id", "options", "value"])
              ])
            ], 64))
      ], 2)
    ])
  ]))
}
}

})